import React from "react";
import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";
import { useTranslation } from "react-i18next";
import PerfectScrollbar from "react-perfect-scrollbar";

const InventoryVitrineCard = ({ inventory, onSelect, isPopular = false }) => {
  const { t } = useTranslation();

  const renderScopes = (scopes) => {
    if (!scopes || scopes.length === 0) return null;
    return (
      <ul className="text-12 mb-0 ps-3">
        {scopes.map((scope) => (
          <li key={scope.id} className="mb-1">
            {scope.name}
            {scope.subScopes && scope.subScopes.length > 0 && (
              <ul className="ps-3">
                {scope.subScopes.map((subScope) => (
                  <li key={subScope.id}>{subScope.name}</li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <Card className="vitrine-card vitrine-card-inventory h-100 position-relative" onClick={() => onSelect(inventory)}>
      {/* Popular or New Badge */}
      {isPopular && (
        <div className="position-absolute top-0 end-0 m-3">
          <Badge bg="light" text="danger" className="d-flex align-items-center gap-1">
            <i className="bi bi-heart-fill"></i>
            <span>{t("popular")}</span>
          </Badge>
        </div>
      )}

      <Card.Body className="d-flex flex-column p-4">
        {/* Title */}
        <div className="mb-3">
          <h5 className="fw-bold mb-1">{inventory.name}</h5>
          <p className="text-muted small mb-0">{inventory.description}</p>
        </div>

        {/* Meta Info */}
        <div className="d-flex align-items-center gap-3 mb-3">
          <div className="d-flex align-items-center gap-1">
            <i className="bi bi-clock"></i>
            <span className="text-13">{inventory.questionNumber || 0} {t("questions")}</span>
          </div>
        </div>

        {/* Scopes Content */}
        <div className="vitrine-card-info flex-grow-1">
          <PerfectScrollbar options={{ suppressScrollX: true }}>
            {inventory.scopes && inventory.scopes.length > 0 && (
              <div>
                <h6 className="text-primary fw-semibold mb-2 text-14">{t("scopes")}</h6>
                {renderScopes(inventory.scopes)}
              </div>
            )}
          </PerfectScrollbar>
        </div>

        {/* Footer with Details Button */}
        <div className="mt-auto pt-3 border-top">
          <button className="btn btn-outline-dark w-100 rounded-pill">{t("details")}</button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default InventoryVitrineCard;
